import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

class Tape extends Component {
  constructor(props) {
    super(props);

    this.activateButton = this.activateButton.bind(this);
    this.deactivateButton = this.deactivateButton.bind(this);

    this.state = {
      isButtonActive: false
    };
  }

  componentDidMount() {
    const { history } = this.props;
    setTimeout(() => {
      history.push('/final');
    }, 3500);
  }

  activateButton() {
    this.setState({
      isButtonActive: true
    });
  }

  deactivateButton() {
    this.setState({
      isButtonActive: false
    });
  }

  render() {
    return (
      <div className="container full-width full-height overflow-no" style={{ maxHeight: '100vh' }}>
        <div className="row">
          <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4 text-center">
            <div className="force-vertical-horizontal-center front">
              <div className="tape-wrap" />
              <div className="dialog dialog-bubble dialog-tape">
                錄影帶GET
              </div>
            </div>
          </div>
        </div>
        <CSSTransitionGroup
          transitionName="fadein"
          transitionAppear
          transitionEnterTimeout={1600}
          transitionLeaveTimeout={1600}
          transitionAppearTimeout={1600}
        >
          <div className="col-xs-12 img-glow spin" />
        </CSSTransitionGroup>
      </div>
    );
  }
}

Tape.propTypes = {
  history: PropTypes.shape().isRequired
};

export default Tape;



// WEBPACK FOOTER //
// ./app/components/Tape.js